import { Component, OnInit, Input, Inject } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot
} from '@angular/router';

import { HttpClient } from '@angular/common/http';

declare const loadDocument: any;
declare const saveDocument: any;
declare const loadData: any;


import { SystemLog } from './../shared/models/sysLog.model';
import { User } from './../_models/index';
import { DemoService } from './../demo.service';
import { GlobalFunctionsService } from './../services/global-functions.service';


@Component({
  // moduleId: module.id.toString(),
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  public _http: HttpClient;
  public _baseUrl: string;

  public today = Date.now();
  @Input() log_data: SystemLog;
  log: SystemLog[] = [];

  currentUser: User;
  currentUserSession: User;
  users: User[] = [];
  get_access_level: any;
  sessionUserId: any;
  sessionUserName: any;
  sessionBrandId: any;
  sessionUserLevel: any;
  sessionUserFullName: any;
  returned_created_file_id: any;
  system_log_created_response: Object;

  constructor( public router: Router, private _demoService: DemoService,
     public gfunc: GlobalFunctionsService,
     // ASP
  //   http: HttpClient, @Inject('BASE_URL') baseUrl: string
     ) {

    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
   
    // sets to session storage if localStorage Collection is not set. // prevents going to home page and hanging there.
    if (sessionStorage.getItem('currentUser')){
    /* */
    // get the user roll and auto redirect this page on load.
    this.get_access_level = this.currentUser.access_level;
    // Set loggind in User Value (USER ID)
    this.sessionUserId = this.currentUser.user_id;
    this.sessionUserName = this.currentUser.username;
    this.sessionBrandId = this.currentUser.brand_id;
    this.sessionUserLevel = this.currentUser.access_level;
    this.sessionUserFullName = this.currentUser.first_name + ' ' + this.currentUser.surname;


// txc server











 }

    // TRUE SESSIONS: this is now a session build so it will work old way as well.
    this.currentUserSession = JSON.parse(sessionStorage.getItem('currentUser'));
    // if the new session exists then go back to the old system
    if (sessionStorage.getItem('currentUser')) {
      this.get_access_level = this.currentUserSession.access_level;
      // Set loggind in User Value (USER ID)
      this.sessionUserId = this.currentUserSession.user_id;
      this.sessionUserName = this.currentUserSession.username;
      this.sessionBrandId = this.currentUserSession.brand_id;
      this.sessionUserLevel = this.currentUserSession.access_level;
      this.sessionUserFullName = this.currentUserSession.first_name + ' ' + this.currentUserSession.surname;
    }


    // insert log
    this.log_data = {
      // log_id: null,
      // log_content: null, // inserts the entire JSON action into mysql cell
      // log_action: '', // automated / updated / created / uploaded / link_created / sent / accessed
      // created_by: this.sessionUserId,
      // created_date: this.today,
      // subject_id: null,
      // job_id: null,
      // job_reference_number: null,
      // file_number: null,
      // reference_number: null,
      // subject_number: null,
      // log_type_id: 5, // see datatable system_log_types
      // created_level: 2, // staff manager
      // brand_type_id: null,
      // subject_com_type_id: null,
      // subject_template_doc_id: null,
      // log_name: 'User Login: ' + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ' + this.today,
      // file_id: this.returned_created_file_id,
      log_content: JSON.stringify(this.currentUser), // inserts the entire JSON action into mysql cell
      log_action: 'login', // automated / updated / created / uploaded / link_created / sent / accessed
      created_by: this.gfunc.sessionUserId,
      created_date: this.gfunc.today,
      subject_id: null,
      job_id: null,
      job_reference_number: null,
      file_number: null,
      reference_number: null,
      subject_number: null,
      log_type_id: 5 , // see datatable system_log_types
      created_level: this.sessionUserLevel, // staff manager
      brand_type_id: null,
      subject_com_type_id: null,
      subject_template_doc_id: null,
      log_name: 'User Logged Into System: ' + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ')',
      file_id: null,
      brand_id: this.sessionBrandId,
      user_id: this.sessionUserId

    };

    this.createSystemLog(this.log_data);

    if (this.get_access_level === '1') {
      // redirect the page.
      this.router.navigate(['/admin']);
    }


    // New accounting and staff level Access - Accounting Focused.
    // if (this.get_access_level === '2') {
    //   // redirect the page.
    //   this.router.navigate(['/accounts']);
    // }

    if (this.get_access_level === '3') {
      // redirect the page.
      this.router.navigate(['/manager']);
    }

    if (this.get_access_level === '9') {
      // redirect the page.
      this.router.navigate(['/client']);
    }

    if (this.get_access_level === '4') {
      // redirect the page.
      this.router.navigate(['/staff']);
    }

    if (this.get_access_level === '5') {
      // redirect the page.
      this.router.navigate(['/agent']);
    }


    // just in case
    if (!this.get_access_level) {
      // redirect the page.
      this.router.navigate(['/login']);
    }

  }

  ngOnInit() {
    //  this.loadAllUsers();
  }



  createSystemLog(model) {
    this._demoService.createSystemLog(model).subscribe(
      data => { this.system_log_created_response = data; },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }

  // deleteUser(id: number) {
  //   this.userService.delete(id).subscribe(() => { this.loadAllUsers(); });
  // }

  // private loadAllUsers() {
  //   this.userService.getAll().subscribe(users => { this.users = users; });
  // }

}

